import * as moment from 'moment-timezone';

export default class Utils {
  static convertDateTime(date, time) {
    if (date.length && time.length) {
      const momentParse = moment.tz(`${date} ${time}`, 'DD-MM-YYYY HH:mm', 'Europe/Amsterdam');
      
      return momentParse;
    }
    return null;
  }

  static formatTimeForApi(datetime) {
    if (datetime !== undefined) {
      const format = 'YYYY-MM-DDTHH:mm:ss';
      const formattedDatetime = datetime.format(`${format}Z`); // local datetime with offset

      return formattedDatetime;
    }

    return null;
  }

  static getFormData(form) {
    return form.serializeArray().reduce((obj, item) => {
      const object = obj;
      object[item.name] = item.value;

      return object;
    }, {});
  }
}
